(() => {
  'use strict';
  const root = document.querySelector('[data-vp-ys]');
  const node = document.querySelector('[data-ys-config]');
  if (!root || !node) return;
  let cfg;
  try { cfg = JSON.parse(node.textContent); } catch { return; }
  const money = cents => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', useGrouping: false,
    minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
  }).format(cents / 100);
  const params = new URLSearchParams(location.search);
  let trade = cfg.trades.find(t => t.id === params.get('trade')) || cfg.trades[0];
  let size = '18x24';
  const image = t => cfg.imageUrls?.[t.id] || (cfg.assetPrefix || '') + 'vp-yard-' + t.id + '-freepik.webp';
  const previewScales = {'12x18': 1, '18x24': 1.2, '24x36': 1.45};
  function render() {
    root.dataset.ysSelectedSize = size;
    root.style.setProperty('--ys-preview-scale', previewScales[size]);
    root.querySelectorAll('[data-ys-preview-size]').forEach(label => { label.textContent = size.replace('x', ' × ') + ' in'; });
    const main = root.querySelector('[data-ys-main-image]');
    main.src = image(trade);
    main.alt = 'Generated ' + trade.name + ' yard-sign mockup with sample company name and phone number';
    root.querySelector('[data-ys-hook]').textContent = trade.hook;
    root.querySelector('[data-ys-trade-label]').textContent = trade.name.toUpperCase() + ' / SAMPLE DESIGN';
    root.querySelector('[data-ys-workwear]').href = '/pages/custom-' + trade.workwear + '-workwear';
    root.querySelectorAll('[data-ys-trade]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ysTrade === trade.id)));
    root.querySelectorAll('[data-ys-size]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ysSize === size)));
    const variants = cfg.variants.filter(v => v.size === size && v.available);
    const base = variants.find(v => v.quantity === 10);
    const hero = cfg.variants.find(v => v.size === size && v.quantity === 10);
    if (hero) root.querySelector('[data-ys-hero-price]').textContent = money(hero.price);
    const heroSize = root.querySelector('[data-ys-hero-size]');
    if (heroSize) heroSize.textContent = '10 signs · ' + size.replace('x', ' × ') + ' in';
    root.querySelector('[data-ys-size-note]').textContent = size === '24x36'
      ? '36 in wide × 24 in high · Full-color both sides · 4mm white corrugated plastic · One H-stake per sign.'
      : size.replace('x', ' × ') + ' in · Full-color corrugated plastic signs. Confirm print sides and stakes with Varaprint before ordering.';
    const quantities = size === '24x36' ? [10, 25, 50, 100] : [10, 20, 50, 100];
    const shown = quantities.map(q => variants.find(v => v.quantity === q)).filter(Boolean);
    const largestPrice = Math.max(...shown.map(v => v.price));
    const lowestEach = Math.min(...shown.map(v => v.price / v.quantity));
    const grid = root.querySelector('[data-ys-pack-grid]');
    grid.replaceChildren();
    for (const v of shown) {
      const q = v.quantity;
      const count = q / 10;
      const savings = base && Number.isInteger(count) && count > 1 ? base.price * count - v.price : 0;
      const percent = base ? Math.floor((1 - (v.price / q) / (base.price / 10)) * 100) : 0;
      const best = shown.length > 1 && v.price === largestPrice && v.price / q === lowestEach;
      const article = document.createElement('article');
      article.className = 'ys-pack' + (best ? ' ys-pack-best' : '');
      const label = q === 10 ? 'START SMALL' : q === 50 ? 'STOCK UP' : 'MORE JOBS';
      article.innerHTML = (best ? '<div class="ys-best-ribbon"><span class="ys-best-dots" aria-hidden="true"><i></i><i></i><i></i><i></i></span><strong>BEST VALUE</strong><small>AMONG THESE PACKS</small></div>' : '') +
        '<div class="ys-pack-header"><h3>' + q + ' Yard Signs</h3><span>' + (best ? 'BULK SAVINGS' : label) + '</span></div>' +
        '<figure class="ys-pack-image"><span class="ys-preview-size" data-ys-preview-size>' + size.replace('x', ' × ') + ' in</span><div class="ys-pack-photo"><img width="1600" height="1195" loading="lazy" alt=""></div><span class="ys-qty-circle"><b>' + q + '</b><small>SIGNS</small></span></figure>' +
        '<div class="ys-pack-price"><span>' + (best ? 'Your best-value pack price' : 'Pack price') + '</span><div class="ys-price-line"><strong>' + money(v.price) + '</strong>' + (!best ? '<small>' + money(Math.round(v.price / q)) + ' / sign</small>' : '') + '</div>' +
        (best ? '<p class="ys-best-each">Only <b>' + money(Math.round(v.price / q)) + '</b> per sign</p>' : '') +
        '<p class="ys-pack-saving">' + (savings > 0 ? (best ? '<b>Save ' + money(savings) + '</b><span>vs ' + count + ' × 10-sign packs</span>' : 'Save ' + money(savings) + ' vs ' + count + ' × 10-sign packs') : 'One company design across your pack') + '</p>' +
        (best && percent > 0 ? '<p class="ys-best-percent">' + percent + '% lower per sign than the 10-pack rate</p>' : '') + '</div>' +
        '<div class="ys-pack-bottom"><p>' + size.replace('x', ' × ') + ' in · Full-color printing<br>' + (size === '24x36' ? q + ' signs + ' + q + ' H-stakes · Both sides' : 'Sides and stakes: confirm before ordering') + '</p>' +
        '<a class="ys-button" data-ys-order>' + (best ? 'Get the ' + q + '-Sign Pack' : 'Customize & Order') + ' <span aria-hidden="true">↗</span></a><a class="ys-link" data-ys-view>View this pack</a></div>';
      article.querySelector('img').src = image(trade);
      article.querySelector('img').alt = 'Generated ' + trade.name + ' sample design for the ' + q + '-sign pack, ' + size.replace('x', ' by ') + ' inches; illustrative size preview';
      const url = 'https://varaprint.com/products/yard-signs?variant=' + v.id;
      article.querySelector('[data-ys-order]').href = url;
      article.querySelector('[data-ys-view]').href = url;
      grid.append(article);
    }
  }
  root.addEventListener('click', event => {
    const b = event.target.closest('[data-ys-trade],[data-ys-size]');
    if (!b) return;
    if (b.dataset.ysTrade) {
      trade = cfg.trades.find(t => t.id === b.dataset.ysTrade) || trade;
      const url = new URL(location.href);
      url.searchParams.set('trade', trade.id);
      history.replaceState(null, '', url);
    }
    if (b.dataset.ysSize) size = b.dataset.ysSize;
    render();
  });
  render();
})();
